<template functional>
  <article class="home-blog-post-gallery-post">
    <a :href="props.post.sourceUrl || (props.post.baseUrl + props.post.fullUrl)" target="_blank">
      <img alt="" loading="lazy" :src="props.post.assetUrl" class="post-image"/>
      <h4 class="post-name">{{ $options.methods.unescape(props.post.title) }}</h4>
    </a>
  </article>
</template>
<script>
import unescape from "lodash/unescape";
export default {
  name: 'BlogPost',
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    unescape
  }
};
</script>

<style lang="postcss">
.home-blog-post-gallery-post {
  @apply flex flex-col items-center cursor-pointer relative;

  a,
  a:hover,
  a:focus,
  a:active {
    all: unset;
  }

  &:before{
    background-image: url('~@/assets/icons/external-link.png');
    background-size: cover;
    background-position: center center;
    content: '';
    position: absolute;
    right: 15px;
    top: 5px;
    opacity: 0;
    color: white;
    width: 20px;
    height: 20px;
    transition: opacity .3s;
  }
  &:hover:before{
    opacity: 1;

  }

  .post-image {
    aspect-ratio: 310 / 176;
    max-width: 310px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .post-name {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    text-align: left;
    max-width: 310px;
    color: #000000;
  }
}
</style>